import React from 'react';

const AdminBadge = ({
  children,
  variant = 'default', // 'default', 'success', 'warning', 'error', 'info', 'active', 'pending', 'suspended'
  size = 'md', // 'sm', 'md', 'lg'
  dot = false,
  className = ''
}) => {
  const variantClasses = {
    default: 'admin-badge-default',
    success: 'admin-badge-success',
    warning: 'admin-badge-warning',
    error: 'admin-badge-error',
    info: 'admin-badge-info',
    active: 'admin-badge-active',
    pending: 'admin-badge-pending',
    suspended: 'admin-badge-suspended',
  };

  const sizeClasses = {
    sm: 'admin-badge-sm',
    md: 'admin-badge-md',
    lg: 'admin-badge-lg',
  };

  return (
    <span className={`admin-badge ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {dot && <span className="admin-badge-dot" />}
      {children}
    </span>
  );
};

export default AdminBadge;

